export var localizations = {
  name: {
    en: "Block Puzzle Color Puzzles",
    ru: "Block Puzzle Цветные Пазлы",
  },
  gameOverTitle: {
    en: "Congratulations!",
    ru: "Поздравляю!",
  },
  score: {
    en: "Score",
    ru: "Счёт",
  },
  restart: {
    en: "Start over",
    ru: "Начать сначала",
  },
  resize: {
    en: "Choose a size!",
    ru: "Выберите размер!",
  },
  close: {
    en: "Close",
    ru: "Закрыть",
  },
  chooseSize: {
    en: "Choose a size",
    ru: "Выбрать размер",
  },
};

export var getLanguage = function () {
  if (!window.ysdk) {
    return "en";
  } else {
    var language = window.ysdk.environment.i18n.lang;
    if (language !== "en" && language !== "ru") {
      return "en";
    } else {
      return language;
    }
  }
};
